const KakaoSection = () => {
  return (
    <section className="py-16 bg-[#FEE500]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* Left: Text */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-black/10 rounded-full px-4 py-1.5 mb-5">
              <span className="text-xs font-bold text-stone-800 tracking-wide">실시간 상담 가능</span>
            </div>
            <h2
              className="text-3xl md:text-4xl font-black text-stone-900 mb-3 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              궁금한 점이 있으신가요?
            </h2>
            <p className="text-stone-700 text-sm leading-relaxed mb-2">
              도어준 카카오톡 오픈채팅으로 빠르게 문의하세요.
            </p>
            <p className="text-stone-600 text-xs">
              제품 선택 · 설치 일정 · 가격 문의 · A/S 접수 모두 가능합니다.
            </p>
          </div>

          {/* Center: Card */}
          <div className="bg-white rounded-2xl p-8 flex flex-col items-center gap-5 w-full max-w-xs">
            {/* Kakao Icon */}
            <div className="w-16 h-16 flex items-center justify-center bg-[#FEE500] rounded-2xl">
              <svg viewBox="0 0 24 24" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3C6.477 3 2 6.477 2 10.8c0 2.7 1.6 5.1 4 6.6l-1 3.6 4.2-2.8c.9.2 1.8.3 2.8.3 5.523 0 10-3.477 10-7.8S17.523 3 12 3z" fill="#3A1D1D"/>
              </svg>
            </div>

            <div className="text-center">
              <p className="text-base font-black text-stone-900 mb-1">도어준 공식 오픈채팅</p>
              <p className="text-xs text-stone-500">평균 응답시간 5분 이내</p>
            </div>

            {/* Features */}
            <ul className="w-full space-y-2">
              {[
                { icon: "ri-chat-1-line", text: "실시간 1:1 상담" },
                { icon: "ri-calendar-check-line", text: "설치 일정 예약" },
                { icon: "ri-price-tag-3-line", text: "견적 문의" },
                { icon: "ri-tools-line", text: "A/S 접수" },
              ].map((item) => (
                <li key={item.text} className="flex items-center gap-2.5 bg-stone-50 rounded-lg px-3 py-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-stone-600 text-sm`} />
                  </div>
                  <span className="text-xs font-medium text-stone-700">{item.text}</span>
                </li>
              ))}
            </ul>

            <a
              href="https://open.kakao.com/o/srLtta1b"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-full flex items-center justify-center gap-2 bg-[#FEE500] hover:bg-[#FFD700] text-stone-900 text-sm font-black py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3C6.477 3 2 6.477 2 10.8c0 2.7 1.6 5.1 4 6.6l-1 3.6 4.2-2.8c.9.2 1.8.3 2.8.3 5.523 0 10-3.477 10-7.8S17.523 3 12 3z" fill="#3A1D1D"/>
              </svg>
              카카오톡으로 문의하기
            </a>
          </div>

          {/* Right: Stats */}
          <div className="flex-1 flex flex-col gap-4 w-full lg:max-w-xs">
            {[
              { value: "5분", label: "평균 응답 시간", icon: "ri-time-line" },
              { value: "98%", label: "고객 만족도", icon: "ri-thumb-up-line" },
              { value: "24시간", label: "상담 가능 시간", icon: "ri-customer-service-2-line" },
              { value: "무료", label: "상담 비용", icon: "ri-gift-line" },
            ].map((s) => (
              <div key={s.label} className="flex items-center gap-4 bg-black/10 rounded-xl px-5 py-4">
                <div className="w-9 h-9 flex items-center justify-center bg-white/60 rounded-lg flex-shrink-0">
                  <i className={`${s.icon} text-stone-800`} />
                </div>
                <div>
                  <p className="text-lg font-black text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</p>
                  <p className="text-xs text-stone-700">{s.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KakaoSection;
